import { ICourse } from '../../admin/courses/store';
import { IPlayer, IUserStore } from '../../user/store';

export interface IOfficer {
  position: string;
  user: IPlayer;
}

export interface IClub {
  index: string | null;
  about?: string;
  backgroundImage?: string | null;
  course: ICourse;
  description: string;
  email: string;
  id: number;
  managements: IOfficer[];
  members: IPlayer[];
  membershipPrice: string;
  name: string;
  owner?: IUserStore;
  policy?: string;
  processPayment: boolean;
  profileImage?: string | null;
  status?: string;
}

export interface IClubsStore {
  all: {
    [id: number]: IClub;
  };
  [id: number]: IClub;
}

export const clubsStore = { all: {} };
